export default { 
    paymentType (state) {
        return state.paymentType
    }
}